import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export async function requestParametricAiSuggestion({
  patternType,
  cellName,
  prompt,
  currentParameters,
  designContext,
  conversation,
}) {
  const response = await axios.post(
    `${API_BASE_URL}/parametric/ai/parameter-suggestion`,
    {
      patternType,
      cellName,
      prompt,
      currentParameters,
      designContext,
      conversation,
    }
  );

  if (!response.data?.success || !response.data?.data) {
    throw new Error("The AI service returned an invalid response.");
  }

  return response.data.data;
}


export function getParametricAiErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Unable to generate a parameter proposal."
  );
}
